import React, { useState } from "react";
import "./FBAR.css";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown";
import CustomSwitch from "../../Components/CustomSwitch/CustomSwitch";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import BackIcon from "../../assets/images/client-dashboard/adddepinfo-banbtnbackicon.svg";
import { useNavigate } from "react-router-dom";
const ClientDashboardFBAR = () => {
  const [residentialAddresses, setResidentialAddresses] = useState([
    { year: 2020, state: "", from: "", to: "" },
  ]);
  const navigate = useNavigate();
  const addResidentialAddress = (index) => {
    const newYear = residentialAddresses[index]?.year + 1;
    if (!residentialAddresses.some((address) => address.year === newYear)) {
      setResidentialAddresses((prevAddresses) => [
        ...prevAddresses,
        {
          year: newYear,
          state: "",
          from: "",
          to: "",
        },
      ]);
    } else {
      // Handle the case when the year already exists (e.g., show an error message)
      // You can add your own logic here
    }
  };
  const removeResidentialAddress = (index) => {
    setResidentialAddresses((prevAddresses) =>
      prevAddresses.filter((_, i) => i !== index)
    );
  };
  return (
    <div className="clientdashboard__fbar_section">
      <div className="clientdashboard__fbar_wrapper">
        <div className="clientdashboard__fbar_innersection">
          <div className="clientdashboard__fbar_inrsecheader">
            <div> Foreign Bank Account Reporting (FBAR) – 2023</div>
            <div className="clientdashboard__fbar_ishsubheading">
              A United States person, including a citizen, resident,
              corporation, partnership, limited liability company, trust and
              estate, must file FBAR.If the person transferred or maintained the
              aggregate value of those foreign financial accounts exceeded
              $10,000 at any time during the calendar year need to file
            </div>
          </div>
          <div className="clientdashboard__fbar_inrsecbody">
            <div className="clientdashboard__fbar_inrsecrow">
              <div className="clientdashboard__fbar_inrseccolleft">
                <label className="clientdashboard__fbar_inputlbl">
                  Foreign Financial account
                </label>
                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Financial Account"
                />
              </div>
              <div className="clientdashboard__fbar_inrseccol">
                <label className="clientdashboard__fbar_inputlbl">
                  Ownership
                </label>
                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Write Ownership Name"
                />
              </div>
            </div>
            <div className="clientdashboard__fbar_inrsecrow">
              <div className="clientdashboard__fbar_inrseccolleft">
                <label className="clientdashboard__fbar_inputlbl">
                  Name of Bank or Financial Institution
                </label>
                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Name of the bank"
                />
              </div>
              <div className="clientdashboard__fbar_inrseccol">
                <label className="clientdashboard__fbar_inputlbl">
                  Street Address
                </label>

                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter Address"
                />
              </div>
            </div>
            <div className="clientdashboard__fbar_inrsecrow">
              <div className="clientdashboard__fbar_inrseccolleft">
                <label className="clientdashboard__fbar_inputlbl">City</label>
                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter City"
                />
              </div>
              <div className="clientdashboard__fbar_inrseccol">
                <label className="clientdashboard__fbar_inputlbl">State</label>

                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter State"
                />
              </div>
            </div>
            <div className="clientdashboard__fbar_inrsecrow">
              <div className="clientdashboard__fbar_inrseccolleft">
                <label className="clientdashboard__fbar_inputlbl">
                  Postal Code
                </label>
                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter Postal Code"
                />
              </div>
              <div className="clientdashboard__fbar_inrseccol">
                <label className="clientdashboard__fbar_inputlbl">
                  Account Number
                </label>

                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter Account Number"
                />
              </div>
            </div>
            <div className="clientdashboard__fbar_inrsecrow">
              <div className="clientdashboard__fbar_inrseccolleft">
                <label className="clientdashboard__fbar_inputlbl">
                  Type of Account
                </label>
                <CustomDropdown
                  options={["Savings Account", "Current"]}
                  customStyles={{
                    height: 60,
                    border: "1px solid lightgrey",
                    marginTop: 5,
                  }}
                />
              </div>
              <div className="clientdashboard__fbar_inrseccol">
                <label className="clientdashboard__fbar_inputlbl">
                  If others, please specify
                </label>

                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter Description"
                />
              </div>
            </div>
            <div className="clientdashboard__fbar_inrsecrow">
              <div className="clientdashboard__fbar_inrseccolleft">
                <label className="clientdashboard__fbar_inputlbl">
                  Foreign currency in which acct is maintained (INR, EUR, GBP,
                  etc.)
                </label>
                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Ex: INR"
                />
              </div>
              <div className="clientdashboard__fbar_inrseccol">
                <label className="clientdashboard__fbar_inputlbl">
                  Income earned in the account during 2020
                </label>

                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter Amount"
                />
              </div>
            </div>
            <div className="clientdashboard__fbar_inrsecrow">
              <div className="clientdashboard__fbar_inrseccolleft">
                <label className="clientdashboard__fbar_inputlbl">
                  Total income earned in the account during 2020 (If line 7
                  'YES' please provide income details)
                </label>
                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter Details"
                />
              </div>
              <div className="clientdashboard__fbar_inrseccol">
                <label className="clientdashboard__fbar_inputlbl">
                  Maximum Value of Account during 2020 in Foreign currency
                </label>

                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter Amount"
                />
              </div>
            </div>
            <div className="clientdashboard__fbar_inrsecrow">
              <div className="clientdashboard__fbar_inrseccolleft">
                <label className="clientdashboard__fbar_inputlbl">
                  Value of Account as on 31-Dec-2020 in Foreign currency
                </label>
                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter Value"
                />
              </div>
              <div className="clientdashboard__fbar_inrseccol">
                <label className="clientdashboard__fbar_inputlbl">
                  Name of Joint Owner (if not spouse)
                </label>

                <input
                  type="text"
                  className="clientdashboard__fbar_inputfield"
                  placeholder="Enter Name"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="clientdashboard__depndtinfo_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="clientdashboard__depndtinfo_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="clientdashboard__depndtinfo_cbirttxt">
            I declare that the information in this application is true and
            correct
          </div>
        </div>
      </div>

      <br />
      <div className="clientdashboard__fbar_wrapper">
        <div className="clientdashboard__fbar_bottombtns">
          <button className="clientdashboard__fbar_bottombtn1">Save</button>
          <button className="clientdashboard__fbar_bottombtn2">Reset</button>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardFBAR;
